module.exports = __webpack_public_path__ + "static/img/9.565ad4a.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content-management/9.jpeg
// module id = q/z7
// module chunks = 3